export function useUrgentCountriesList() {
    return ["AT", "BE", "PL", "DE", "CH"]
}